import React, { useEffect, useState, useCallback } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { useQueryClient } from '@tanstack/react-query';
// @YUp
import * as Yup from "yup";
import { Button, Grid, TextField, FormControl, MenuItem, Select, FormHelperText } from "@mui/material";
import API from "../../utils/Axios.utils";
import { Notification } from "../../utils/Notification";
import FIelds from "../../uicomponents/FIelds";
import TextArea from "../../uicomponents/TextArea";
import CustomSelect from "../../uicomponents/CustomSelect";
import CustomMultiSelect from "../../uicomponents/CustomMultiSelect";
import TextEditor from "../../utils/TextEditor";
import useAuth from "../../hooks/useAuth";

// Style constants to prevent recreation on every render
const containerStyle = { marginTop: 20 };
const formContainerStyle = {
  border: "1px solid #989898",
  borderRadius: "10px",
  padding: "15px",
};
const headerStyle = {
  fontFamily: "Roboto, Helvetica, Arial, sans-serif",
  fontSize: "20px",
  fontWeight: "500",
  letterSpacing: 1,
  textAlign: "left",
};
const gridContainerStyle = { display: "grid" };
const labelStyle = { fontSize: "16px" };
const requiredStyle = { color: 'red' };

const EditJob = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [isFormSubmitted, setIsFormSubmitted] = React.useState(false);

  // Snackbar
  const [alert, setAlert] = React.useState(false);
  const [alertContent, setAlertContent] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const location = useLocation();
  const jobDetails = location.state?.jobDetails;
  console.log('jobDetails :- ', jobDetails)
  const handleAlert = () => {
    setAlert(false);
  };

  const [editorContent, setEditorContent] = React.useState(
    jobDetails.job_description
  );
  const [clearData, setClearData] = React.useState(false);

  // For Validation
  const [editorIsEmpty, setEditorIsEmpty] = React.useState(false);

  // Skill Data
  const [skillData, setSkillData] = useState([]);

  const handleEditorEmptyChange = (isEmpty) => {
    setEditorIsEmpty(isEmpty);
  };
  // validation code end

  const handleContentChange = (content) => {
    // Handle the editor content here (e.g., store it in state)
    setEditorContent(content);
  };

  const initialValues = {
    title: jobDetails.title,
    // location: jobDetails.location,
    location: (() => {
      try {
        const raw = jobDetails?.location;
        if (!raw) return '';

        // Already array
        if (Array.isArray(raw)) {
          return raw.join(', ');
        }

        if (typeof raw === 'string') {
          let trimmed = raw.trim();

          // Case A: double‑encoded array → "\"[\"Pune\",\"Mumbai\"]\""
          // First parse outer string, then inner array
          if (trimmed.startsWith('"') && trimmed.endsWith('"') && trimmed.includes('[')) {
            const inner = JSON.parse(trimmed);          // → "[\"Pune\",\"Mumbai\"]"
            const arr = JSON.parse(inner);             // → ["Pune","Mumbai"]
            return arr.join(', ');
          }

          // Case B: JSON array string ["Pune","Mumbai"]
          if (trimmed.startsWith('[')) {
            return JSON.parse(trimmed).join(', ');
          }

          // Case C: escaped single string "\"Pune\""
          if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
            return JSON.parse(trimmed);                // → "Pune"
          }

          // Case D: plain string "Pune"
          return trimmed;
        }

        return '';
      } catch (e) {
        console.log('initialValues.location parse error:', jobDetails?.location, e);
        return '';
      }
    })(),
    experience: jobDetails.experience,
    currency: jobDetails.currency,
    budget: jobDetails.budget,
    budget_uom: jobDetails.budget_uom,
    mode_of_work: jobDetails.mode_of_work,
    notice_period: jobDetails.notice_period,
    // primary_skills: jobDetails.primary_skills,
    job_description: jobDetails.job_description,
    status: jobDetails.job_status,
    notes: jobDetails.notes,
    coreSkillId: jobDetails?.coreSkillId,      // NEW
    techSkills: jobDetails?.techSkills,
    customer_id: jobDetails.customer_id || '',
    contact_id: jobDetails?.contact_person?.contact_id || '',
    no_of_requirements: jobDetails.no_of_requirements || 1,
    contact_person_name: jobDetails.contact_person_name || '',
    contact_person_number: jobDetails.contact_person_number || '',
    contact_person_email: jobDetails.contact_person_email || '',
    fulfilled_count: jobDetails.fulfilled_count || 0,
    background_verification: jobDetails.background_verification === 'Yes' ? true : false,
    assignment_duration_days: jobDetails.assignment_duration_days || 90
  };

  const { token } = useAuth();

  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  // const onSubmit = async (values) => {
  //   if (editorIsEmpty) {
  //     setIsFormSubmitted(true);
  //   } else {
  //     values.job_description = editorContent;
  //     try {
  //       const res = await API.put(
  //         `/api/job/${jobDetails.job_id}`,
  //         values,
  //         config
  //       );
  //       setAlertContent(res?.data?.message);
  //       setAlertType("success");
  //       setAlert(true);
  //       setTimeout(() => {
  //         navigate("/jobs");
  //       }, 1500);
  //     } catch (error) {
  //       setAlertContent(error?.response?.data?.message);
  //       setAlertType("error");
  //       setAlert(true);
  //     }
  //   }
  // };

  // const onSubmit = async (values) => {
  //   if (editorIsEmpty) {
  //     setIsFormSubmitted(true);
  //     return;
  //   }

  //   values.job_description = editorContent;
  //   const parts = values.location
  //     ? values.location.split(',').map(loc => loc.trim()).filter(loc => loc)
  //     : [];

  //   let finalLocation;
  //   if (parts.length === 1) {
  //     finalLocation = parts[0];                  // "Pune"
  //   } else if (parts.length > 1) {
  //     finalLocation = JSON.stringify(parts);     // ["Pune","Mumbai"]
  //   } else {
  //     finalLocation = '';
  //   }

  //   const payload = {
  //     ...values,
  //     location: finalLocation,
  //     background_verification: values.background_verification ? 'Yes' : 'No',
  //   };

  //   try {
  //     const res = await API.put(`/api/job/${jobDetails.job_id}`, payload, config);

  //     const { message, showAlert, alertType, fulfillment } = res?.data || {};

  //     // Build enhanced message for full-filled jobs
  //     let finalMessage = message || "Job updated successfully.";
  //     if (showAlert && alertType === "FULL_FILLED" && fulfillment) {
  //       finalMessage = `${message} All ${fulfillment.total} positions are now filled! 🎉`;
  //     }

  //     setAlertContent(finalMessage);
  //     setAlertType("success");
  //     setAlert(true);

  //     setTimeout(() => {
  //       navigate("/jobs");
  //     }, 2000); // Slightly longer for full-filled message
  //   } catch (error) {
  //     setAlertContent(error?.response?.data?.message || "Update failed");
  //     setAlertType("error");
  //     setAlert(true);
  //   }
  // };

  const onSubmit = async (values) => {
    if (editorIsEmpty) {
      setIsFormSubmitted(true);
      return;
    }

    values.job_description = editorContent;
    const parts = values.location
      ? values.location.split(',').map(loc => loc.trim()).filter(loc => loc)
      : [];

    let finalLocation;
    if (parts.length === 1) {
      finalLocation = parts[0];
    } else if (parts.length > 1) {
      finalLocation = JSON.stringify(parts);
    } else {
      finalLocation = '';
    }

    const payload = {
      ...values,
      location: finalLocation,
      background_verification: values.background_verification ? 'Yes' : 'No',
    };

    try {
      const res = await API.put(`/api/job/${jobDetails.job_id}`, payload, config);
      const data = res?.data || {};

      // ✅ Handle detailed error responses (just error field)
      if (data.error) {
        setAlertContent(data.error);
        setAlertType("error");
        setAlert(true);
        return;
      }

      // ✅ Success with enhanced messaging
      let finalMessage = data.message || "Job updated successfully.";
      const { showAlert, alertType, fulfillment, status_priority, auto_updated } = data;

      // 🎉 Full-filled celebration
      if (showAlert && alertType === "FULL_FILLED" && fulfillment) {
        finalMessage = `${finalMessage} All ${fulfillment.total} positions filled! 🎉`;
      }

      // 📋 Status info
      // if (status_priority === 'override') {
      //   finalMessage += " Status manually overridden.";
      // } else if (auto_updated) {
      //   finalMessage += " Status auto-updated.";
      // }

      setAlertContent(finalMessage);
      setAlertType("success");
      setAlert(true);

      // Invalidate React Query cache to refresh job list
      queryClient.invalidateQueries({ queryKey: ['jobs'] });

      setTimeout(() => {
        const from = location.state?.from || "";
        navigate(`/jobs${from}`);
      }, 2500);

    } catch (error) {
      // ✅ Use error field first, fallback to message
      const errData = error?.response?.data || {};
      setAlertContent(errData.error || errData.message || "Update failed");
      setAlertType("error");
      setAlert(true);
    }
  };



  const validationSchema = Yup.object().shape({
    title: Yup.string()
      .required("Job title is required.")
      .min(2, "Minimum 2 characters are required.")
      .max(100, "Maximum length is 100 characters.")
      .test(
        "no-empty-or-spaces",
        "Title must not be empty or contain only spaces.",
        (value) => value?.trim().length > 0
      )
      .test(
        "no-leading-trailing-spaces",
        "Leading and trailing spaces are not allowed.",
        (value) => value === value?.trim()
      )
      .matches(
        /^[a-zA-Z0-9.,#\-_ ]+$/,
        "Please use only letters, numbers, spaces, and symbols: . , # - _"
      ),
    location: Yup.string()
      .required('Location is required')
      .test('valid-locations', 'Invalid location format', function (value) {
        if (!value?.trim()) return false;
        const locationArray = value.split(',').map(loc => loc.trim()).filter(loc => loc.length > 0);
        const locationRegex = /^[a-zA-Za-z\s]+$/;
        const isValid = locationArray.every(loc =>
          loc.length >= 2 &&
          loc.length <= 50 &&
          locationRegex.test(loc)
        );
        return isValid && locationArray.length > 0;
      }),
    experience: Yup.string()
      .min(1, "Minimum 1 caharacter is required.")
      .max(4, "Maximum length is 4 characters.")
      .required("This field is required."),
    currency: Yup.string().required("This field is required."),
    budget: Yup.string().required("This field is required."),
    budget_uom: Yup.string().required("This field is required."),
    mode_of_work: Yup.string().required("This field is required."),
    notice_period: Yup.string()
      .min(1, 'Minimum 1 day is required.')
      .max(4, 'Maximum length is 4 characters.')
      .required('Notice period is required.')
      .matches(/^\d+$/, 'Must be numbers only (days)'),
    // job_description: Yup.string()
    //   .min(2, "Minimum 2 caharacter is required.")
    //   .max(100, "Maximum length is 100 characters.")
    //   .required("This field is required."),
    status: Yup.string().required("This field is required."),
    // notes: Yup.string()
    //   .min(2, "Minimum 2 caharacter is required.")
    //   .max(255, "Maximum length is 255 characters.")
    //   .notRequired(),

    notes: Yup.string()
      .max(255, "Maximum length is 255 characters.")
      .when("status", {
        is: (status) =>
          ["Hold", "Cancelled", "Close-No_Client_Response", "Close-Unable_To_Fulfill"]
            .includes(status),
        then: (schema) =>
          schema
            .required("Notes are required when job status is Hold / Cancelled / Closed")
            .min(2, "Minimum 2 characters are required."),
        otherwise: (schema) => schema.notRequired(),
      }),
    // .required("This field is required."),
    // primary_skills: Yup.array().required("This field is required."),
    coreSkillId: Yup.number()
      .typeError("This field is required.")
      .required("This field is required."),
    techSkills: Yup.array().required("This field is required."),
    customer_id: Yup.number()
      .typeError("This field is required")
      .required("Customer is required"),
    contact_id: Yup.number()
      .nullable()
      .when('customerid', {
        is: (customerid) => !!customerid,
        then: (schema) => schema.required('Contact person is required'),
        otherwise: (schema) => schema.notRequired()
      }),
    no_of_requirements: Yup.number()
      .min(1, "Minimum 1 requirement")
      .required("No. of requirements is required"),
    contact_person_name: Yup.string().max(50, "Max 50 characters"),
    contact_person_number: Yup.string()
      .matches(/^[\+]?[1-9][\d]{0,15}$/, "Invalid phone number"),
    contact_person_email: Yup.string().email("Invalid email"),
    fulfilled_count: Yup.number()
      .min(0, "Cannot be negative")
      .when("status", {
        is: (val) => val === "Partially-Fulfilled",
        then: (schema) =>
          schema
            .required("Filled positions required for this status")
            .min(1, "Filled positions must be at least 1 for Partially Filled status")
            .test(
              "less-than-req",
              "Filled positions must be less than total requirements for Partially Filled status",
              function (value) {
                const { no_of_requirements } = this.parent;
                if (!no_of_requirements || value == null) return true;
                return value < no_of_requirements;
              }
            ),
        otherwise: (schema) => schema,
      })
      .when("status", {
        is: (val) => val === "Full-Filled",
        then: (schema) =>
          schema
            .required("Filled positions required for this status")
            .test(
              "equals-req",
              "Filled positions must equal total requirements for Full Filled status",
              function (value) {
                const { no_of_requirements } = this.parent;
                if (!no_of_requirements || value == null) return true;
                return value >= no_of_requirements; // Allow equal or greater (over-hired)
              }
            ),
        otherwise: (schema) => schema,
      }),
    background_verification: Yup.boolean().required('Background verification is required'),
    assignment_duration_days: Yup.number()
      .min(1, 'Minimum 1 day')
      .max(3650, 'Maximum 10 years (3650 days)')
      .required('Assignment duration is required'),
  });

  const getSkills = async () => {
    let url = `/api/skill/skill_list`;

    try {
      const res = await API.get(url, config);
      const formattedSkills = res?.data?.skill?.map((skill) => ({
        id: skill.skill_id,
        value: skill.skill_name,
        label: skill.skill_name,
      }));
      setSkillData(formattedSkills);
    } catch (error) {
      console.log("error", error);
    }
  };
  const [coreSkills, setCoreSkills] = useState([]);
  const [techSkills, setTechSkills] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [customerContacts, setCustomerContacts] = useState([]);
  const [locations, setLocations] = useState([]);

  const getLocations = () => {
    try {
      let locationArray = [];

      if (!jobDetails?.location) {
        setLocations([]);
        return;
      }

      const locationValue = jobDetails.location.trim();

      // Case 1: Single plain string "Pune"
      if (locationValue && !locationValue.startsWith('[') && !locationValue.includes(',')) {
        locationArray = [locationValue];
      }
      // Case 2: JSON array string ["Pune","Mumbai"] or "[\"Pune\",\"Mumbai\"]"
      else if (locationValue.startsWith('[')) {
        locationArray = JSON.parse(locationValue);
      }
      // Case 3: Single escaped JSON string "\"Pune\""
      else if (locationValue.startsWith('"') && locationValue.endsWith('"')) {
        const unescaped = JSON.parse(locationValue); // "\"Pune\"" → "Pune"
        locationArray = [unescaped];
      }
      // Case 4: Already array (fallback)
      else if (Array.isArray(jobDetails.location)) {
        locationArray = jobDetails.location;
      }

      // Format for state
      const formattedLocations = Array.isArray(locationArray)
        ? locationArray.map((loc, index) => ({
          id: index,
          value: loc,
          label: loc
        }))
        : [];

      setLocations(formattedLocations);

      // Update formik initial value for display
      const displayValue = Array.isArray(locationArray)
        ? locationArray.join(', ')
        : locationArray.toString();

      // Note: Formik initialValues handles display separately

    } catch (error) {
      console.log('Location parse error:', error);
      console.log('Raw location:', jobDetails?.location);
      setLocations([]);
    }
  };


  const getCoreSkills = async () => {
    try {
      const res = await API.get("/api/core-skill/coreSkills", config);
      const formattedCore = res?.data?.coreSkills?.map(item => ({
        id: item.id,
        value: item.id,
        label: item.name,
      }));
      setCoreSkills(formattedCore);
    } catch (error) {
      console.log("getCoreSkills error", error);
    }
  };

  // const getTechSkillsByCore = async (coreSkillId) => {
  //   if (!coreSkillId) {
  //     setTechSkills([]);
  //     return;
  //   }
  //   try {
  //     const res = await API.get(`/api/tech-skill/alltechSkills/${coreSkillId}`, config);
  //     const formattedTech = res?.data?.techSkills?.map(item => ({
  //       id: item.id,
  //       value: item.name,  // Use name as value for techSkills array of strings
  //       label: item.name,
  //     }));
  //     setTechSkills(formattedTech);
  //   } catch (error) {
  //     console.log("getTechSkillsByCore error", error);
  //   }
  // };

  const getTechSkillsByCore = async (coreSkillId) => {
    if (!coreSkillId) {
      setTechSkills([]);
      return;
    }
    try {
      const res = await API.get(`/api/tech-skill/alltechSkills/${coreSkillId}`, config);
      const formattedTech = res?.data?.techSkills?.map(item => ({
        id: item.id,
        value: item.name,
        label: item.name,
      }));

      // ADD "All Skills" option (NEW)
      const allSkillsOption = { id: 'all', value: 'All Skills', label: 'All Skills' };
      setTechSkills([allSkillsOption, ...formattedTech]); // ← CHANGED
    } catch (error) {
      console.log("getTechSkillsByCore error", error);
    }
  };

  // Add this function before the main return (
  const handleTechSkillsChange = (event, form) => {
    const selectedValues = event.target.value;

    if (selectedValues.includes('All Skills')) {
      // Select ALL available tech skills (exclude "All Skills" itself)
      const allTechSkills = techSkills
        .filter(skill => skill.value !== 'All Skills')
        .map(skill => skill.value);
      form.setFieldValue('techSkills', allTechSkills);
    } else {
      form.setFieldValue('techSkills', selectedValues);
    }
  };

  const getCustomers = async () => {
    try {
      const res = await API.get('/api/customer/active_customer_list', config);
      const formattedCustomers = res?.data?.customers?.map(item => ({
        id: item.customer_id,
        value: item.customer_id,
        label: `${item.name}`,
        customer_code: item.customer_code,
        name: item.name
      }));
      setCustomers(formattedCustomers);
    } catch (error) {
      console.log('getCustomers error:', error);
    }
  };
  const getCustomerContacts = useCallback(async (customerId) => {
    if (!customerId) {
      setCustomerContacts([]);
      return;
    }
    try {
      const res = await API.get(`/api/customer/CustomersContacts/${customerId}`, config);
      const formattedContacts = res?.data?.contacts?.map(item => ({
        id: item.contact_id,
        value: item.contact_id,
        label: `${item.name}`,
        name: item.name,
        email: item.email,
        phone: item.phone
      }));
      setCustomerContacts(formattedContacts);
    } catch (error) {
      console.log('getCustomerContacts error', error);
    }
  }, [config]);

  useEffect(() => {
    getSkills();
    getCoreSkills();
    getCustomers();
    getLocations();
    if (initialValues.coreSkillId) {
      getTechSkillsByCore(initialValues.coreSkillId);
    }
    if (jobDetails?.customer_id) {
      getCustomerContacts(jobDetails.customer_id); // Load contacts for existing job
    }
  }, []);

  const navigateToPreviousPage = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const handleCustomerChange = useCallback((value, form) => {
    form.setFieldValue('customer_id', value);
    getCustomerContacts(value); // Fetch contacts
    form.setFieldValue('contact_id', ''); // Reset contact
  }, [getCustomerContacts]);

  const handleContactChange = useCallback((value, form) => {
    form.setFieldValue('contact_id', value);
  }, []);

  const handleLocationChange = useCallback((value, form) => {
    form.setFieldValue('location', value);
  }, []);

  return (
    <div style={containerStyle}>
      <Button startIcon={<ArrowBackIcon />} onClick={navigateToPreviousPage}>
        Back
      </Button>
      <div
        style={formContainerStyle}
      >
        <div
          style={headerStyle}
        >
          <span>Edit Job</span>
          <div style={gridContainerStyle}>
            <Formik
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchema}
            >
              {(props) => (
                <Form noValidate>
                  <Grid container spacing={2}>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Job Title <span style={{ color: 'red' }}>*</span></span>
                      <Field
                        as={TextField}
                        name="title"
                        fullWidth
                        error={props.errors.title && props.touched.title}
                        size="small"
                        helperText={<ErrorMessage name="title" />}
                        required
                      />{" "}
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={labelStyle}>Customer <span style={requiredStyle}>*</span></span>
                      <Field name="customer_id">
                        {({ field, form }) => (
                          <FormControl fullWidth variant="outlined" size="small" error={form.touched.customer_id && Boolean(form.errors.customer_id)}>
                            <Select
                              {...field}
                              onChange={(event) => handleCustomerChange(event.target.value, form)}
                              displayEmpty
                            >
                              {customers.map((option) => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>
                              <ErrorMessage name="customer_id" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={labelStyle}>Contact Person <span style={requiredStyle}>*</span></span>
                      <Field name="contact_id">
                        {({ field, form }) => (
                          <FormControl fullWidth variant="outlined" size="small" error={form.touched.contact_id && Boolean(form.errors.contact_id)}>
                            <Select
                              {...field}
                              value={field.value || ''}
                              onChange={(event) => handleContactChange(event.target.value, form)}
                              displayEmpty
                            >
                              {customerContacts.map(option => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: 'red' }}>
                              <ErrorMessage name="contact_id" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>

                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Location</span>
                      <FIelds name="location" props={props} />
                    </Grid> */}

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={labelStyle}>
                        Locations <span style={requiredStyle}>*</span>
                      </span>
                      <Field name="location">
                        {({ field, form, meta }) => (
                          <TextField
                            {...field}
                            value={field.value || ''}
                            onChange={(e) => handleLocationChange(e.target.value, form)}
                            fullWidth
                            size="small"
                            placeholder="Pune, Mumbai, Bangalore"
                            error={meta.touched && Boolean(meta.error)}
                            helperText={
                              meta.touched && meta.error
                                ? <ErrorMessage name="location" />
                                : 'Enter multiple locations separated by commas'
                            }
                          />
                        )}
                      </Field>

                    </Grid>




                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Experience <span style={{ color: 'red' }}>*</span></span>
                      <FIelds name="experience" props={props} onInput="yes" />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Currency <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="currency"
                        props={props}
                        options={allCurrency}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Budget <span style={{ color: 'red' }}>*</span></span>
                      <FIelds name="budget" props={props} onInput="yes" />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Budget UOM <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="budget_uom"
                        props={props}
                        options={budgetUOM}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Work Mode <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="mode_of_work"
                        props={props}
                        options={WorkMode}
                      />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>
                        Timeline (Days) <span style={{ color: 'red' }}>*</span>
                      </span>
                      <FIelds
                        name="notice_period"
                        props={props}
                        onInput="yes"
                      />
                    </Grid>
                    {/* Assignment Duration - Add after Notice Period, before Core Skill */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Assignment Duration (Days) <span style={{ color: 'red' }}>*</span></span>
                      <Field
                        as={TextField}
                        name="assignment_duration_days"
                        type="number"
                        fullWidth
                        error={props.errors.assignment_duration_days && props.touched.assignment_duration_days}
                        size="small"
                        helperText={<ErrorMessage name="assignment_duration_days" />}
                        inputProps={{ min: 1, max: 3650 }}
                        placeholder="90"
                        required
                      />
                    </Grid>

                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Primary Skills</span>
                      <CustomMultiSelect
                        name="primary_skills"
                        props={props}
                        options={skillData}
                      />
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Core Skill <span style={{ color: 'red' }}>*</span></span>
                      <Field name="coreSkillId">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.coreSkillId && Boolean(form.errors.coreSkillId)}
                          >
                            <Select
                              {...field}
                              displayEmpty
                              onChange={(event) => {
                                const value = event.target.value;
                                form.setFieldValue("coreSkillId", value);
                                form.setFieldValue("techSkills", []); // reset tech skills on core skill change
                                getTechSkillsByCore(value);
                              }}
                              size="small"
                              variant="outlined"
                            >
                              {coreSkills.map(option => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: "red" }}>
                              <ErrorMessage name="coreSkillId" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Tech Skills</span>
                      <Field name="techSkills">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.techSkills && Boolean(form.errors.techSkills)}
                          >
                            <Select
                              multiple
                              displayEmpty
                              {...field}
                              value={field.value || []}
                              onChange={event => {
                                form.setFieldValue("techSkills", event.target.value);
                              }}
                              onBlur={field.onBlur}
                              size="small"
                              variant="outlined"
                            >
                              {techSkills.map(option => (
                                <MenuItem key={option.id} value={option.value}>
                                  {option.label}
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ color: "red" }}>
                              <ErrorMessage name="techSkills" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid> */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Tech Skills <span style={{ color: 'red' }}>*</span></span>
                      <Field name="techSkills">
                        {({ field, form }) => (
                          <FormControl
                            fullWidth
                            variant="outlined"
                            size="small"
                            error={form.touched.techSkills && Boolean(form.errors.techSkills)}
                          >
                            <Select
                              multiple
                              displayEmpty
                              {...field}
                              value={field.value || []}
                              onChange={(event) => handleTechSkillsChange(event, form)}
                              onBlur={field.onBlur}
                              size="small"
                              variant="outlined"
                              renderValue={(selected) => (
                                <div
                                  style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 6,
                                    maxHeight: 60,        // ✅ Prevents stretching
                                    overflowY: "auto"     // ✅ Scroll instead of grow
                                  }}
                                >
                                  {selected.map((value) => (
                                    <span
                                      key={value}
                                      style={{
                                        background: "#E3F2FD",
                                        padding: "4px 8px",
                                        borderRadius: 12,
                                        fontSize: "13px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {value}
                                    </span>
                                  ))}
                                </div>
                              )}
                            >
                              {/* "All Skills" option - NEW */}
                              <MenuItem value="All Skills">All Skills</MenuItem>
                              {/* Regular tech skills (exclude "All Skills" from selectable list) */}
                              {techSkills
                                .filter(option => option.value !== 'All Skills')
                                .map(option => (
                                  <MenuItem key={option.id} value={option.value}>
                                    {option.label}
                                  </MenuItem>
                                ))}
                            </Select>
                            <FormHelperText sx={{ color: "red" }}>
                              <ErrorMessage name="techSkills" />
                            </FormHelperText>
                          </FormControl>
                        )}
                      </Field>
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Status <span style={{ color: 'red' }}>*</span></span>
                      <CustomSelect
                        name="status"
                        props={props}
                        options={allStatus}
                      />
                    </Grid>
                    {/* BGV CHECKBOX - Add after Work Mode Grid, before Notice Period */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>BGV</span>
                      <Field name="background_verification">
                        {({ field, form, meta }) => (
                          <FormControl fullWidth error={meta.touched && Boolean(meta.error)} size="small">
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <input
                                type="checkbox"
                                checked={field.value || false}
                                onChange={(e) => form.setFieldValue('background_verification', e.target.checked)}
                                style={{ width: '18px', height: '18px', accentColor: '#2777AA' }}
                              />
                              <span style={{ fontSize: '16px', fontWeight: '500' }}>
                                Background Verification
                              </span>
                            </div>
                            {meta.touched && meta.error && (
                              <FormHelperText sx={{ color: 'red', marginLeft: '26px' }}>
                                {meta.error}
                              </FormHelperText>
                            )}
                          </FormControl>
                        )}
                      </Field>
                    </Grid>

                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Numbers of Requirements <span style={{ color: 'red' }}>*</span></span>
                      <Field as={TextField}
                        name="no_of_requirements"
                        type="number"
                        fullWidth
                        error={props.errors.no_of_requirements && props.touched.no_of_requirements}
                        size="small"
                        helperText={<ErrorMessage name="no_of_requirements" />}
                        required
                        inputProps={{ min: 1, max: 100 }}
                      />
                    </Grid>
                    {/* ✅ NEW: Filled Positions field */}
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}>
                      <span style={{ fontSize: '16px' }}>Filled Positions</span>
                      <Field
                        as={TextField}
                        name="fulfilled_count"
                        type="number"
                        fullWidth
                        error={props.errors.fulfilled_count && props.touched.fulfilled_count}
                        size="small"
                        helperText={<ErrorMessage name="fulfilled_count" />}
                        inputProps={{ min: 0, max: 100 }}
                      />
                    </Grid>
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid> */}
                    {/* <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid> */}
                    <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Notes</span>
                      <TextArea name="notes" props={props} />
                    </Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
                    <Grid item xl={4} lg={4} md={6} sm={12} xs={12}></Grid>
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <span style={{ fontSize: "16px" }}>Job Description <span style={{ color: "red" }}>*</span></span>
                      <TextEditor
                        getContent={handleContentChange}
                        setClearData={setClearData}
                        clearData={clearData}
                        initialContent={jobDetails.job_description}
                        onEditorEmptyChange={handleEditorEmptyChange}
                      />
                      {isFormSubmitted && editorIsEmpty && (
                        <div
                          style={{
                            color: "#d32f2f",
                            marginLeft: "14px",
                            fontWeight: 400,
                            fontSize: "0.75rem",
                          }}
                        >
                          This Field is required
                        </div>
                      )}
                    </Grid>

                    {/* Submit */}
                    <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="contained"
                          aria-haspopup="true"
                          style={{
                            background: !props.isValid || !editorContent || !editorContent.replace(/<[^>]*>/g, '').trim() ? "#ccc" : "#2777AA",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "16px",
                            fontWeight: "500",
                            letterSpacing: 1,
                          }}
                          type="submit"
                          disabled={!props.isValid || !editorContent || !editorContent.replace(/<[^>]*>/g, '').trim()}
                        >
                          Update
                        </Button>
                      </div>
                    </Grid>
                  </Grid>
                  <Notification
                    message={alertContent}
                    open={alert}
                    severity={alertType}
                    onClose={handleAlert}
                  />
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditJob;

const WorkMode = [
  { id: 1, value: "remote", label: "Work Remotely" },
  { id: 2, value: "office", label: "Work From Office" },
  { id: 3, value: "hybrid", label: "Hybrid" },
];
const allStatus = [
  { id: 1, value: "Active", label: "Active" },
  { id: 2, value: "Full-Filled", label: "Full-Filled" },
  { id: 3, value: "Critical", label: "Critical" },
  { id: 4, value: "Hold", label: "Hold" },
  { id: 5, value: "Cancelled", label: "Cancelled" },
  { id: 6, value: "Partially-Fulfilled", label: "Partially-Fulfilled" },
  { id: 7, value: "Close-No_Client_Response", label: "Close-No Client Response" },
  { id: 8, value: "Close-Unable_To_Fulfill", label: "Close-Unable To Fulfill" },
];
const allCurrency = [
  { id: 1, value: "INR", label: "INR" },
  { id: 2, value: "USD", label: "USD" },
  { id: 3, value: "GBP", label: "GBP" },
];
const budgetUOM = [
  { id: 1, value: "perHour", label: "Per Hour" },
  { id: 2, value: "perMonth", label: "Per Month" },
  { id: 3, value: "perDay", label: "Per Day" },
  { id: 4, value: "perYear", label: "Per Year" },

];